var _defs, _use;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgClock(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "a",
    d: "M12.8333333,12.8333333 L7.01916667,12.8333333 C6.62,12.8333333 6.29666667,12.51 6.29666667,12.1108333 L6.29666667,12.1025 C6.29666667,11.7041667 6.62,11.3808333 7.01916667,11.3808333 L11.3808333,11.3808333 L11.3808333,5.56666667 C11.3808333,5.1675 11.7041667,4.84416667 12.1033333,4.84416667 L12.1116667,4.84416667 C12.51,4.84416667 12.8333333,5.1675 12.8333333,5.56666667 L12.8333333,12.8333333 Z M12,2 C6.4775,2 2,6.4775 2,12 C2,17.5225 6.4775,22 12,22 C17.5225,22 22,17.5225 22,12 C22,6.4775 17.5225,2 12,2 L12,2 Z"
  }))), _use || (_use = /*#__PURE__*/React.createElement("use", {
    className: "colorize",
    fillRule: "evenodd",
    xlinkHref: "#a"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgClock);
export default __webpack_public_path__ + "static/media/clock.2b52d00ca73c5df4ce83df51b12af190.svg";
export { ForwardRef as ReactComponent };